/**
 * List of existing connections between assets
 */
import type React from "react";
import type { CompositionLink } from "../../types";
import { ConnectionLinkItem } from "../../shared";

export interface WireConnectionListProps {
  links: CompositionLink[];
  selectedLinkId: string | null;
  getAssetName: (id: string) => string;
  onSelectLink: (id: string | null) => void;
  onRemoveLink: (id: string) => void;
}

export const WireConnectionList: React.FC<WireConnectionListProps> = ({
  links,
  selectedLinkId,
  getAssetName,
  onSelectLink,
  onRemoveLink,
}) => {
  if (links.length === 0) {
    return (
      <p className="text-sm text-sa-text-muted text-center py-4">
        No connections yet. Use the form above to connect asset interfaces.
      </p>
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-sa-text">Connections ({links.length}):</p>
      {links.map((link) => (
        <ConnectionLinkItem
          key={link.id}
          link={link}
          isSelected={selectedLinkId === link.id}
          sourceName={getAssetName(link.source_id)}
          targetName={getAssetName(link.target_id)}
          onSelect={onSelectLink}
          onRemove={onRemoveLink}
        />
      ))}
    </div>
  );
};
